module.exports = __webpack_public_path__ + "static/media/jingle-win.6de77bcd.ogg";